
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile-app",
      function () {
        return require("private-next-pages/mobile-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile-app"])
      });
    }
  